import CurrenctCoin from "../assets/CurrencyCoin.png";

export const RustyRoyalCoin = ({ size = 20 }) => {
  return (
    <div
      className="m-0 p-0"
      style={{ minWidth: size, width: size, height: size + 2 }}
    >
      <img
        src={CurrenctCoin}
        alt=""
        className=""
        style={{ minWidth: size, width: size, marginTop: "-4px" }}
      />
    </div>
  );
};

export const ModelCrossIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 6L6 18"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
